const goFullScreen = async () => {
  try {
    await document.body.requestFullscreen();
  } catch (error) {
    console.error('Failed to enter fullscreen:', error);
  }
};

export const Fullscreen = () => {
  return (
    <div className='h-max-full w-max-full absolute h-full w-full'>
      <div className='flex h-full w-full items-center justify-center p-6'>
        <button
          className='xs:block h-12 rounded-md bg-amber-400 px-4 py-1.5 text-sm font-bold text-gray-900 shadow-sm hover:bg-amber-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600'
          onClick={goFullScreen}
        >
          Go Full Screen
        </button>
      </div>
    </div>
  );
};
